/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { defaultValues } from "../../data/constants/demanderAvenant"
import { IError } from "../../data/types/interface/demanderAvenant"
import { MESSAGE_VALIDATION, WHITESPACE_VALIDATION } from "./validation"

const listRequiredField = (required: Array<any>, notRequired: Array<any>) => {
    const aResult = required.filter(elt => !notRequired.includes(elt[0]))
    return aResult
}

export const Validation = (values: IError, listAgence?: [], listContrat?: []) => {
    let errors: IError = { ...defaultValues }
    const aNotRequiredField = ['']
    const aRequiredField = listRequiredField(Object.entries(values), aNotRequiredField)
   
    if(WHITESPACE_VALIDATION.test(values.message))
    {
        errors.message=MESSAGE_VALIDATION.requiredField
    }
    /** checking all values */ 
    aRequiredField.forEach(element => {
        if (element[1] === '' || element[1] === null || (Array.isArray(element[1]) && element[1].length === 0)) {
            errors = { ...errors, [element[0]]: MESSAGE_VALIDATION.requiredField }
        }
    })

    return errors;
}